// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"598fd26f","425":"da0df225","612":"28a54016","635":"b37d60ec"}[chunkId] + ".chunk.js";
};